<template>
  <div class="avecor-table">
    <v-tabs
      fixed-tabs
      dark
      height="30"
      dense
      v-model="selectedCompaniesTab"
      class="promotion-tabs"
      background-color="#F26539"
      style="position:fixed;top:35px;z-index:20;border-bottom:1px solid orange;" 
    >
      <v-tabs-slider color="#FFF" ></v-tabs-slider>
      <v-tab href="#companies">Yritykset</v-tab>
      <v-tab href="#references">Referenssit</v-tab>
    </v-tabs>
    <div v-if="selectedCompaniesTab === 'companies'">
      <v-toolbar dense class="" flat color="white" style="border-top:1px solid #ccc;position:fixed;top:61px;width:100%;background:#FFF !important;z-index:20">
        <v-toolbar-title>Yritykset</v-toolbar-title>
        <v-col sm="2" class="text-left pl-10">
          <div style="font-size:10px"><b>{{amountOfCompanies}}</b> <span style="font-size:10px">Yritystä näkyvillä</span></div>
          <div style="font-size:10px">
            <b>{{amountOfCompaniesNoOrderForTwoYears}} </b>
            <span style="font-size:10px">Yli 2 vuotta ei tilauksia</span>
            <input style="height:11px;vertical-align: middle;" type="checkbox" :checked="showOnlyNoOrdersForTwoYears" @change="showOnlyNoOrdersForTwoYears = !showOnlyNoOrdersForTwoYears"/> 
            <!-- <span style="vertical-align: middle;padding-left:5px;">Eri laskutusosoite?</span> -->
          </div>
          <div style="font-size:10px">
            <b>{{amountOfCompaniesWithoutSalesperson}} </b>
            <span style="font-size:10px">Yrityksiä ilman myyjää</span>
            <input style="height:11px;vertical-align: middle;" type="checkbox" :checked="showOnlyWithoutSalesperson" @change="showOnlyWithoutSalesperson = !showOnlyWithoutSalesperson"/> 
            <!-- <span style="vertical-align: middle;padding-left:5px;">Eri laskutusosoite?</span> -->
          </div>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="8" md="4">
          <v-text-field
            :value="companiesSearch"
            class="table-search avecor-no-underline"
            label="Hae yrityksiä (nimi, y-tunnus, osoite, kaupunki, netvisor id, myyjä)"
            autocomplete="off"
            @change="(event) => companiesSearch = event"
            hide-details
          ></v-text-field>
        </v-col>
        <v-spacer v-if="device === 'desktop'"></v-spacer>
        <!--<v-btn @click.stop="importCompanies" color="#000000" dark class="add-button mb-2">Import</v-btn>-->
        <!--<input type="file" id="fileInput"></input>
        <button @click="importCompanies" id="submit_button">PARSE FILE</button>-->
        <select v-if="device === 'desktop' && exportAccess" v-model="exportSalespersonFilter" class="status-select mt-0 mr-4" style="height:23px;">
          <option v-for="(sp) in getSalespersons" :key="'salesperson_filter'+sp.id" :value="sp.id">
            {{sp.text}}
          </option>
        </select>

        <!--<v-autocomplete
          v-if="device === 'desktop' && exportAccess"
          style="max-width:200px;z-index:1000"
          label="Myyjä suodatin exporttiin"
          :value="exportSalespersonFilter"
          @change="v => exportSalespersonFilter = v"
          :items="getSalespersons"
          outlined
          dense
          persistent-hint
          item-text="text"
          item-value="id"
          class="avecor-select hide-field-details mr-5 mt-3"
        />      -->   
        <v-menu
          :offset-y="true"
          :nudge-bottom="0"
          :nudge-right="0"
          bottom
          :close-on-click="true"
          v-if="device === 'desktop' && allAccess"
          
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              dark
              v-bind="attrs"
              v-on="on"
              class="avecor-button-global add-button mr-5 "
            >
              Export
            </v-btn>
          </template>

          <v-list>
            <v-list-item><v-list-item-title @click="exportContactsAndLeads('avecor_contacts')" style="cursor:pointer;">Avecorin Asiakkaat</v-list-item-title></v-list-item>
            <v-list-item><v-list-item-title @click="exportContactsAndLeads('avecor_companies_no_salesperson')" style="cursor:pointer;">Avecorin Asiakkaat - Ei myyjää</v-list-item-title></v-list-item>
            <v-list-item><v-list-item-title @click="exportContactsAndLeads('avecor_contacts_no_orders_in_two_years')" style="cursor:pointer;">Yli 2v Ei kauppaa Avecorin Asiakkaat</v-list-item-title></v-list-item>
          </v-list>
        </v-menu>
        <!-- <v-btn v-if="device === 'desktop' && exportAccess" @click.stop="exportContactsAndLeads('avecor_contacts')" color="#000000" dark class="avecor-button-global add-button mb-2 mr-3 mt-3" >Export</v-btn> -->
        <v-btn v-if="device === 'desktop' && exportAccess" @click.stop="exportCities()" color="#000000" dark class="avecor-button-global add-button mb-2 mr-3 mt-3" >Asiakkaat postikoodeittain</v-btn>
        <!-- <div class="text-right" v-if="user.uid === 'p2VRFkTz4JUzqkGoTPUt4CWQAxa2' && device === 'desktop'">
          <input type="file" accept=".csv" id="fileInputCustomers" style="font-size:10px;width:150px;">
          <v-btn @click.stop="importSalesContacts" color="#000000" dark class="avecor-button-global  add-button mr-3">Import</v-btn>
        </div> -->
        <v-btn v-if="device === 'desktop'" @click.stop="newCompanyModalVisible = true" color="#000000" dark class="avecor-button-global add-button mb-2 mt-3 mr-3" >Lisää yritys</v-btn>
        <!-- <v-btn v-if="device === 'desktop'" @click.stop="changeOwner()" color="#000000" dark class="avecor-button-global add-button mb-2 mt-3" >Vaihda asiakkaat</v-btn> -->
      </v-toolbar>
      <CompanyExpand v-if="selectedCompanyId" location="companies"/>
      <div v-if="device === 'desktop'">
        <v-row no-gutters style="background:#EEEEEE;" class="companies-table-headers-sticky" id="companies-table-headers">
          <v-col cols="2">
            <v-row no-gutters>
              <v-col cols="2" class="orders-custom-header pr-1"></v-col>
              <v-col cols="4" class="orders-custom-header pr-1">Luotu pvm</v-col>
              <v-col cols="3" class="orders-custom-header pr-1">Edel. tilaus</v-col>
              <!-- <v-col cols="2" class="orders-custom-header pr-1">Til. määrä</v-col> -->
              <!-- <v-col cols="3" class="orders-custom-header pr-1 pl-2">Viim. kontaktitoitu <br> pvm</v-col> -->
              <v-col cols="3" class="orders-custom-header pr-1">Netvisor Id</v-col>
            </v-row>
          </v-col>
          <v-col cols="7">
            <v-row no-gutters>
              <v-col cols="3" class="orders-custom-header pr-1 pl-2">Yrityksen Nimi</v-col>
              <v-col cols="3" class="orders-custom-header pr-1">Yrityksen kontaktit</v-col>
              <v-col cols="1" class="orders-custom-header pr-1">Myyjä</v-col>
              <v-col cols="1" class="orders-custom-header pr-1">Y-tunnus</v-col>
              <v-col cols="1" class="orders-custom-header pr-1">Toimiala</v-col>
              <v-col cols="3" class="orders-custom-header pr-1">Osoite</v-col>
            </v-row>
          </v-col>
          <v-col cols="3">
            <v-row no-gutters>
              <v-col cols="3" class="orders-custom-header pr-1">Maksuaika</v-col>
              <v-col cols="5" class="orders-custom-header pr-1">Laskutustiedot</v-col>
              <v-col cols="4" class="orders-custom-header pr-1">Status</v-col>
              
            </v-row>
          </v-col>
        </v-row>
      </div>
      <v-container  class="" fluid px-0 pt-0 ma-0 style="position:absolute; top:135px; padding-bottom:500px; width:100%;">
        <v-lazy
          :style="device === 'mobile' ? 'width:100%; padding:0px; margin:0px;min-height:100px' : 'width:100%; padding:0px; margin:0px;min-height:30px;border-top:1px solid #ccc;'"
          :options="{
            threshold: .1
          }"
          v-for="(c) in getCompanies"
          :key="c.id"
        >
          <div>
            <!-- MOBILE -->
            <div v-if="device === 'mobile'" style="width:100%;">
              <v-row no-gutters sm="12" class="pa-1 avecor-company-row" style="">
                <div style="position:absolute; top:15px; right:15px;">
                  <v-icon :size="18" @click="selectedCompanyId = c.id;" style="padding-right:1px;">far fa-eye</v-icon>
                </div>
                <div style="color:rgba(0,0,0,.38); font-size:12px;width:100%" class="px-2">
                  <v-row no-gutters class="py-2" > 
                    <v-col cols="3" class="pr-4">
                      <span style="font-size:14px"><b>Myyjä</b></span>
                    </v-col>
                    <v-col cols="9">
                      <div class="justify-center" >
                        <div style="font-size:14px"><b>{{staff[c.salesperson] !== undefined ? staff[c.salesperson].firstName: ''}}</b></div>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row no-gutters class="py-2" > 
                    <v-col cols="3" class="pr-4">
                      <span style="font-size:14px"><b>Yrityksen nimi</b></span>
                    </v-col>
                    <v-col cols="9">
                      <div class="justify-center" >
                        <div style="font-size:14px"><b>{{c.companyName}}</b></div>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row no-gutters  > 
                    <v-col cols="3" class="pr-4">
                      <span >Luotu pvm</span>
                    </v-col>
                    <v-col cols="9">
                      <div class="justify-center" >
                        <div>{{customFormatter(c.created_at)}}</div>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row no-gutters class="py-2" > 
                    <v-col cols="3" class="pr-4">
                      <span >Y-tunnus</span>
                    </v-col>
                    <v-col cols="9">
                      <div class="justify-center" >
                        <div>{{c.companyId}}</div>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row no-gutters class="py-2" > 
                    <v-col cols="3" class="pr-4">
                      <span>Osoite</span>
                    </v-col>
                    <v-col cols="9">
                      <div class="justify-center" >
                        <div>{{c.deliveryAddress+' '+ c.deliveryPostalCode+' '+c.deliveryCity+', '+c.deliveryCountry}}</div>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row no-gutters class="py-2" > 
                    <v-col cols="3" class="pr-4">
                      <span>Yrityksen kontaktit</span>
                    </v-col>
                    <v-col cols="9">
                      <div class="justify-center" >
                        <div>{{c.contacts}}</div>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </v-row>
            </div>
            <!-- DESKTOP -->
            <div v-if="device === 'desktop'" style="width:100%;">
              <v-row class="pt-1 pb-1" no-gutters  :style="`${ c.noOrdersInTwoYears ? 'background:#FFF3E0;' :''}width:100%; border-bottom:1px solid #ccc;`">
                <v-col cols="2">
                  <v-row no-gutters>
                    <v-col cols="2" class="companies-custom-field text-center" pr-1>
                      <i v-if="(c.salesperson === user.uid) && !allAccess" @click="selectedCompanyId = c.id;" style="padding-right:4px;padding-top:4px;font-size:10px;color:#666;" class="far fa-eye pointer" />
                      <i v-else-if="(c.salesperson !== user.uid && c.noOrdersInTwoYears) && !allAccess" @click="selectedCompanyId = c.id;" style="padding-right:4px;padding-top:4px;font-size:10px;color:#666;" class="far fa-eye pointer" />
                      <i v-else-if="allAccess" @click="selectedCompanyId = c.id;" style="padding-right:4px;padding-top:4px;font-size:10px;color:#666;" class="far fa-eye pointer" />
                      
                      <i v-if="user.uid === 'p2VRFkTz4JUzqkGoTPUt4CWQAxa2' || user.uid === 'wcMZF1c4vsMZAmCsXzSDDwh4PJd2' || user.uid === 'I7RPIfMJIbYurRauvSR35yp9MJD2'" @click="deleteCompany(c)" style="padding-right:4px;padding-top:0px;font-size:10px;color:#666" class="far fa-trash-alt pointer" />
                      <i v-if="user.uid === 'p2VRFkTz4JUzqkGoTPUt4CWQAxa2'" @click="copyToClipboard(c.id)" style="padding-right:4px;padding-top:0px;font-size:10px;color:#666" class="far fa-id-badge pointer" />
                    </v-col>
                    <v-col cols="4" class="companies-custom-field pr-1">
                      <div @click="copyToClipboard(c.created_at ? customFormatter(c.created_at): '')" style="color:rgba(0,0,0,.38);">{{c.created_at ? customFormatter(c.created_at) : ''}}</div>
                    </v-col>
                    <v-col cols="3" class="companies-custom-field pl-0 pr-1">
                      <div @click="copyToClipboard(c.latestOrderDate ? customFormatter(c.latestOrderDate): '')" style="color:rgba(0,0,0,.38);">{{c.latestOrderDate ? c.latestOrderDate: ''}}</div>
                    </v-col>
                    <!-- <v-col cols="2" class="companies-custom-field pr-1">
                      <div @click="copyToClipboard(c.totalOrders ? c.totalOrders: '')" style="color:rgba(0,0,0,.38);">{{c.totalOrders ? c.totalOrders: ''}}</div>
                    </v-col> -->
                    <!-- <v-col cols="3" class="companies-custom-field hide-field-details pr-2"> -->
                      <!-- <v-menu
                        :nudge-right="40"
                        lazy
                        transition="fade-transition"
                        offset-y
                        full-width
                        min-width="30px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-on="on"
                            style="font-size:7px;"
                            filled
                            rounded
                            :value="c.lastContactedDate === undefined || c.lastContactedDate === '' ? 'klikkaa lisää pvm' : c.lastContactedDate"
                          ></v-text-field>
                        </template>
                        
                        <v-date-picker :value="c.lastContactedDate" @change="(c.id, $event,'lastContactedDate')"></v-date-picker>
                      </v-menu> -->
                    <!-- </v-col> -->
                    <v-col cols="3" class="companies-custom-field pr-1">
                      <div @click="copyToClipboard(c.netvisorId)" style="color:rgba(0,0,0,.38);">{{c.netvisorId}}</div>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="7" class="ma-0 pa-0">
                  <v-row no-gutters>
                    <v-col cols="3" class="companies-custom-field pr-1 pl-2">
                      <div @click="copyToClipboard(c.companyName)" :style="c.companyName.includes('Uusi Yritys') ? 'color:#f36638;': 'color:rgba(0,0,0,.38);'">{{c.companyName}}</div>
                    </v-col>
                    <v-col cols="3" class="companies-custom-field pr-1">
                      <div @click="copyToClipboard(c.contacts)" style="color:rgba(0,0,0,.38);">{{c.contacts}}</div>
                    </v-col>
                    <!-- <v-col cols="1" class="orders-custom-field pr-1">
                      <div class="orders-custom-field" @click="copyToClipboard(c.id)" style="color:rgba(0,0,0,.38);">{{c.id}}</div>
                    </v-col> -->
                    <v-col cols="1" class="companies-custom-field pr-0">
                      <div class="" style="width:80%;">
                        <v-autocomplete
                          :value="c.salesperson"
                          :items="getSalespersons"
                          :disabled="!allAccess"
                          @change="v => $store.dispatch('changeSalespersonForCompany', {companyId:c.id,newSalesperson:v})"
                          persistent-hint
                          item-text="text"
                          item-value="id"
                          hide-details
                          dense
                          class="avecor-select hide-field-details minimize-height pt-0 mt-0 order-expand-header-field-value"
                        />
                      </div>
                      <!-- <div style="color:rgba(0,0,0,.38);">{{staff[c.salesperson] !== undefined ? staff[c.salesperson].firstName: ''}}</div> -->
                    </v-col>
                    <v-col cols="1" class="companies-custom-field pr-1">
                      <div @click="copyToClipboard(c.companyId)" style="color:rgba(0,0,0,.38);">{{c.companyId}}</div>
                    </v-col>
                    <v-col cols="1" class="companies-custom-field pr-1">
                      <div class="" style="width:80%;">
                        <v-autocomplete
                          :value="c.industry"
                          :items="Object.entries(settings.industries).map(i => {return i[1] } )"
                          @change="v => inlineSaveCompany(c.id,'industry',v)"
                          persistent-hint
                          item-text="fi"
                          item-value="id"
                          hide-details
                          dense
                          class="avecor-select hide-field-details minimize-height pt-0 mt-0 order-expand-header-field-value"
                        />
                      </div>
                    </v-col>
                    <v-col cols="3" class="companies-custom-field pr-1">
                      <div @click="copyToClipboard(c.deliveryAddress+' '+ c.deliveryPostalCode+' '+c.deliveryCity+' '+c.deliveryCountry)" style="color:rgba(0,0,0,.38);">{{c.deliveryAddress+' '+ c.deliveryPostalCode+' '+c.deliveryCity+', '+c.deliveryCountry}}</div>
                    </v-col>
                    <!-- <v-col cols="1" class="companies-custom-field pr-1">
                      <div @click="copyToClipboard(c.deliveryPostalCode)" style="color:rgba(0,0,0,.38);">{{c.deliveryPostalCode}}</div>
                    </v-col>
                    <v-col cols="1" class="companies-custom-field pr-1">
                      <div @click="copyToClipboard(c.deliveryCity)" style="color:rgba(0,0,0,.38);">{{c.deliveryCity}}</div>
                    </v-col>
                    <v-col cols="1" class="companies-custom-field pr-1">
                      <div @click="copyToClipboard(c.deliveryCountry)" style="color:rgba(0,0,0,.38);">{{c.deliveryCountry}}</div>
                    </v-col> -->
                    
                  </v-row>
                </v-col>
                <v-col cols="3">
                  <v-row no-gutters>
                    <v-col cols="3" class="companies-custom-field pr-1">
                      <div @click="copyToClipboard(c.paymentTerm)" style="color:rgba(0,0,0,.38);">{{c.paymentTerm}}</div>
                    </v-col>
                    <v-col cols="5" class="orders-custom-field pr-1">
                      <div class="orders-companies-field">
                        <!-- <span @click="copyToClipboard(c.billingFormat)" class="pr-2" style="color:rgba(0,0,0,.38);">{{c.billingFormat !==undefined && c.billingFormat !== "" ? settings.billingFormats[c.billingFormat].fi : ""}}</span> -->
                        
                        <span @click="copyToClipboard(c.billingFormat)" class="pr-2" style="color:rgba(0,0,0,.38);">{{c.billingFormat}}</span>
                        <span v-if="c.differentBillingEmail" @click="copyToClipboard(c.billingEmail)" class="pr-2" style="color:rgba(0,0,0,.38);">{{c.billingEmail}}</span>
                        <span v-if="c.differentBillingAddress" @click="copyToClipboard(c.billingAddress)" class="pr-2" style="color:rgba(0,0,0,.38);">{{c.billingAddress}}</span>
                        <span v-if="c.differentBillingAddress" @click="copyToClipboard(c.billingPostalCode)" class="pr-2" style="color:rgba(0,0,0,.38);">{{c.billingPostalCode}}</span>
                        <span v-if="c.differentBillingAddress" @click="copyToClipboard(c.billingCity)" class="pr-2" style="color:rgba(0,0,0,.38);">{{c.billingCity}}</span>
                        <span v-if="c.differentBillingAddress" @click="copyToClipboard(c.billingCountry)" class="pr-2" style="color:rgba(0,0,0,.38);">{{c.billingCountry}}</span>
                        <span v-if="c.billingFormat === 'eInvoice'" @click="copyToClipboard(c.eBillingAddress)" class="pr-2" style="color:rgba(0,0,0,.38);">{{c.eBillingAddress}}</span>
                        <span v-if="c.billingFormat === 'eInvoice'" @click="copyToClipboard(c.eBillingOperator)" class="pr-2" style="color:rgba(0,0,0,.38);">{{c.eBillingOperator}}</span>
                      </div>
                    </v-col>
                    <v-col cols="4" class="orders-custom-field pr-1">
                      <select :value="c.contactStatus" class="status-select mr-5" style="max-width:100px;" @click.stop @change="contactStatus =>updateCompanyContactStatus(c.id, 'contactStatus',contactStatus)">
                        <option value=""></option>
                        <option value="not_contacted">Ei kontaktoitu</option>
                        <option value="called_no_answer">Soitettu - ei vastausta</option>
                        <option value="called_not_interested">Soitettu - ei kinnostunut</option>
                        <option value="meeting_booked">Tapaaminen saatu</option>
                        <option value="offer_sent">Tarjous lähetetty</option>
                        <option value="order_completed">Tilaus tehty</option>
                      </select>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </div>
          </div>
        </v-lazy>
        <v-row no-gutters style="margin-top:50px;margin-bottom:50px;">
          <v-col cols="12" class="text-center">
            <v-btn v-if="isThereMoreCompaniesToShow" color="orange" style="color:#fff" @click="companiesToShow = companiesToShow + companiesToShowIncrement">Näytä lisää yrityksiä</v-btn>
          </v-col>
        </v-row>
        
      </v-container>
    </div>
    <div v-if="selectedCompaniesTab === 'references'">
      <v-toolbar dense class="" flat color="white" style="border-top:1px solid #ccc;position:fixed;top:84px;width:100%;background:#FFF !important;z-index:20">
        <v-toolbar-title>Referenssit</v-toolbar-title>
        <v-col sm="1" pl-4 class="text-center">
          <div style="font-size:14px">{{amountOfReferences}}</div>
          <div style="font-size:10px">Referenssiä</div>
        </v-col>
        <v-spacer></v-spacer>
        <!-- <v-col cols="8" md="4">
          <v-text-field
            :value="companiesSearch"
            class="table-search avecor-no-underline"
            label="Hae yrityksiä (nimi, y-tunnus, osoite, kaupunki, netvisor id, myyjä)"
            autocomplete="off"
            @change="(event) => companiesSearch = event"
            hide-details
          ></v-text-field>
        </v-col> -->
        <v-spacer v-if="device === 'desktop'"></v-spacer>
        <!--<v-btn @click.stop="importCompanies" color="#000000" dark class="add-button mb-2">Import</v-btn>-->
        <!--<input type="file" id="fileInput"></input>
        <button @click="importCompanies" id="submit_button">PARSE FILE</button>-->
        
      </v-toolbar>
      <div v-if="device === 'desktop'">
        <v-row no-gutters style="padding-top:10px;background:#EEEEEE" class="companies-table-headers-sticky" id="companies-table-headers">
          <v-col cols="5">
            <v-row no-gutters>
              <v-col cols="2" class="orders-custom-header pr-1"></v-col>
              <v-col cols="2" class="orders-custom-header pr-1">Luotu pvm</v-col>
              <v-col cols="2" class="orders-custom-header pr-1">Myyjä</v-col>
              <v-col cols="6" class="orders-custom-header pr-1">Keneltä saatu</v-col>
            </v-row>
          </v-col>
          <v-col cols="7">
            <v-row no-gutters>
              <v-col cols="12" class="orders-custom-header pr-1 pl-2">Referenssi</v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>
      <v-container  class="" fluid px-0 pt-0 ma-0 style="position:absolute; top:135px; padding-bottom:500px; width:100%;">
        <v-lazy
          :style="device === 'mobile' ? 'width:100%; padding:0px; margin:0px;min-height:100px' : 'width:100%; padding:0px; margin:0px;min-height:30px'"
          :options="{
            threshold: .1
          }"
          v-for="(r) in getReferences"
          :key="r.id+'-ref'"
        >
          <div>
            <!-- MOBILE -->
            <div v-if="device === 'mobile'" style="width:100%;">
              <v-row no-gutters sm="12" class="pa-1 avecor-company-row" style="">
                <div style="color:rgba(0,0,0,.38); font-size:12px;width:100%" class="px-2">
                  <v-row no-gutters class="py-2" > 
                    <v-col cols="3" class="pr-4">
                      <span style="font-size:14px"><b>Referenssi</b></span>
                    </v-col>
                    <v-col cols="9">
                      <div class="justify-center" >
                        <div style="font-size:14px"><b>{{r.referenceText}}</b></div>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row no-gutters class="py-2" > 
                    <v-col cols="3" class="pr-4">
                      <span style="font-size:14px"><b>Keneltä saatu</b></span>
                    </v-col>
                    <v-col cols="9">
                      <div class="justify-center" >
                        <div style="font-size:14px"><b>{{r.who}}</b></div>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row no-gutters  > 
                    <v-col cols="3" class="pr-4">
                      <span >Milloin saatu</span>
                    </v-col>
                    <v-col cols="9">
                      <div class="justify-center" >
                        <div>{{customFormatter(r.created_at)}}</div>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </v-row>
            </div>
            <!-- DESKTOP -->
            <div v-if="device === 'desktop'" style="width:100%;">
              <v-row class="pt-1 pb-1" no-gutters  style="width:100%; border-bottom:1px solid #ccc;">
                <v-col cols="5">
                  <v-row no-gutters>
                    <v-col cols="2" class="companies-custom-field text-center" pr-1>
                      <v-icon 
                        v-if="user.uid === 'p2VRFkTz4JUzqkGoTPUt4CWQAxa2'"
                        :size="settings.tableActionIconsSize"
                        @click="deleteReference(r.id)"
                        style="padding-right:10px;"
                      >far fa-trash-alt
                      </v-icon>
                    </v-col>
                    <v-col cols="2" class="companies-custom-field pr-1">
                      <div @click="copyToClipboard(r.created_at ? customFormatter(r.created_at): '')" style="color:rgba(0,0,0,.38);">{{r.created_at ? customFormatter(r.created_at) : ''}}</div>
                    </v-col>
                    <v-col cols="2" class="companies-custom-field pr-1">
                      <div @click="copyToClipboard(r.salesperson ? r.salesperson: '')" style="color:rgba(0,0,0,.38);">{{r.salesperson ? r.salesperson : ''}}</div>
                    </v-col>
                    <v-col cols="6" class="companies-custom-field pr-1">
                      <div @click="copyToClipboard(r.whoProvided)" style="color:rgba(0,0,0,.38);">{{r.whoProvided ? r.whoProvided: ''}}</div>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="7" class="ma-0 pa-0">
                  <v-row no-gutters>
                    <v-col cols="12" class="companies-custom-field pr-1 pl-2">
                      <div @click="copyToClipboard(r.referenceText)" style="color:rgba(0,0,0,.38);">{{r.referenceText ? r.referenceText: ''}}</div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </div>
          </div>
        </v-lazy>
      </v-container>


    </div>
    <AddCompany />
  </div>
</template>


<script>
import { mapFields } from 'vuex-map-fields'
import { ExportToCsv } from 'export-to-csv';
import dateFormat from 'dateformat'
import * as Papa from 'papaparse'
import CompanyExpand from './CompanyExpand.vue'
import AddCompany from './AddCompany'
import shared from './../../shared'
import axios from 'axios'

export default {
    components: {
      CompanyExpand,
      AddCompany
    },
    data: () => ({
      selectedCompaniesTab:'companies',
      companiesData: {},
      table: null,
      companiesSearch:'',
      companiesToShow:250,
      companiesToShowIncrement:500,
      isThereMoreCompaniesToShow:false,
      exportSalespersonFilter:'all',
      newContactDialog: false,
      newCompanyDialog: false,
      amountOfCompanies:0,
      amountOfCompaniesNoOrderForTwoYears:0,
      amountOfCompaniesWithoutSalesperson:0,
      showOnlyNoOrdersForTwoYears:false,
      showOnlyWithoutSalesperson:false,
      amountOfReferences:0,
      autogrow: true,
      pagination: {'sortBy': 'companyName', 'descending': false, 'rowsPerPage': 15, 'sortable':false},
      selected: [],
      search: '',
      newItem: {
        salesperson: '',
        companyName: "---Uusi Yritys---",
        companyId: "", 
        paymentTerm: "14 päivää netto",
        deliveryAddress: "",
        deliveryPostalCode: "",
        deliveryCity: "",
        deliveryCountry: "Finland",
        billingAddress: "",
        billingPostalCode: "",
        billingCity: "",
        billingCountry: "",
        eBillingAddress: "",
        companyComments:"",
        totalOrders:0
      },
      defaultItem: {
        salesperson: '',
        companyName: "",
        companyId: "", 
        paymentTerm: "14 päivää netto",
        deliveryAddress: "",
        deliveryPostalCode: "",
        deliveryCity: "",
        deliveryCountry: "Finland",
        billingAddress: "",
        billingPostalCode: "",
        billingCity: "",
        billingCountry: "",
        eBillingAddress: "",
        companyComments:"",
        totalOrders:0
      },
    }),
    created(){
      this.exportContactsAndLeads = shared.exportContactsAndLeads
    },
    mounted() {
      const table = this.$refs.table
      this.generateCompaniesData()
    },
    watch: {
      contacts: {
        handler(val){
          //console.log("GENERATING PRODUCTS DATA")
          this.generateCompaniesData()
        },
        deep: true
      },
      companies: {
        handler(val){
          //console.log("GENERATING PRODUCTS DATA")
          this.generateCompaniesData()
        },
        deep: true
      }
      
    },
    computed: {
      allAccess(){
        return this.staff[this.user.uid] !== undefined && (this.staff[this.user.uid].isAdmin || this.staff[this.user.uid].role == 'office' || this.staff[this.user.uid].role == 'warehouse')
      },
      exportAccess(){
        return this.staff[this.user.uid] !== undefined && (this.staff[this.user.uid].isAdmin || this.staff[this.user.uid].role == 'office')
      },
      companyNames(){
        var names = {}
        Object.keys(this.companies).forEach(c => {
          var name = this.companies[c].companyName
          if(name) {
            name = name.trim()
            names[name] = {salesperson:this.companies[c].salesperson}
          }
        })
        return names
      },
      getSalespersons(){
        var staff = this.staff
        var salespersons = [{text:'--Kaikki--', id:'all'}]
        Object.keys(this.staff).map(function(key, index) {
          var s = staff[key]
          if(s.role === 'sales' || s.id === 'y9ZVH4HpzFWuS9TzONQUJadQZ4T2') salespersons.push({text:s.firstName, id:s.id})
          return {...s}
        })
        salespersons = salespersons.sort((a,b)=>{
          var nameA= a.text.toLowerCase(), nameB=b.text.toLowerCase();
          if (nameA > nameB) {
            return 1;
          }
          if (nameB > nameA) {
            return -1;
          }
          return 0;
        })
        return salespersons
      },
      /* getBillingFormats(){
        var billingFormats = this.settings.billingFormats
        return Object.keys(this.settings.billingFormats).reduce(function(result, key) {
          result.push({...billingFormats[key]});
          return result;
        }, []);
      }, */
      getReferences(){
        var order
        var keys = Object.keys(this.orders)
        var referencesArray = []
        if (keys.length == 0) return []
        for (const key of keys) {
          order = this.orders[key]
          if(order.referenceText){
            console.log(order)
            var salesperson = this.staff[order.salesperson] ? this.staff[order.salesperson].firstName + ' ' + this.staff[order.salesperson].lastName : ''
            var companyName = this.companies[order.companyId] ? this.companies[order.companyId].companyName : ''
            var contactName = this.contacts[order.contactId] ? this.contacts[order.contactId].firstName + this.contacts[order.contactId].lastName : ''
            var whoProvided = companyName + ' - ' + contactName
            if (this.staff[this.user.uid].isAdmin || this.staff[this.user.uid].role === 'office') {
              referencesArray.push({id:order.id, referenceText:order.referenceText, whoProvided,created_at:order.created_at, salesperson})
            }
            else if (this.staff[this.user.uid].role === 'sales'){
              if(order.salesperson === this.user.uid) {
                referencesArray.push({id:order.id, referenceText:order.referenceText, whoProvided,created_at:order.created_at, salesperson})
              }

            }
          }
        }
        this.amountOfReferences = referencesArray.length
        return referencesArray
      },
      getCompanies(){
        var c//, searchText
        
        var keys = Object.keys(this.companiesData)
        //var companiesSearch = this.companiesSearch.toLowerCase()
        var uid = this.user.uid
        var companiesArray = []
        var companySharing = this.settings.companySharing
        var amountOfCompaniesWithoutSalesperson = 0
        var amountOfCompaniesNoOrderForTwoYears = 0

        if (keys.length == 0) return []
        for (const key of keys) {
          c = this.companiesData[key]

          if(!c.salesperson) amountOfCompaniesWithoutSalesperson += 1
          if(c.noOrdersInTwoYears) amountOfCompaniesNoOrderForTwoYears += 1
          // KATRIN FIRMAT
          //if(companySharing[c.salesperson] && companySharing[c.salesperson].includes(uid) && c.noOrdersInTwoYears) {}
          if(companySharing[c.salesperson] && companySharing[c.salesperson].includes(uid)) {}
          else if(this.staff[uid].role === 'sales' && !this.staff[uid].isAdmin && c.salesperson !== uid) continue

          if(this.showOnlyNoOrdersForTwoYears && !c.noOrdersInTwoYears) continue
          
          if(this.showOnlyWithoutSalesperson && c.salesperson) continue


          if (this.companiesSearch !== ""){
            var searchText = ''
            searchText = c.companyName + ' ' + c.deliveryAddress + ' ' + c.deliveryPostalCode + ' ' + c.deliveryCity + ' ' + c.netvisorId + ' ' + ' ' + c.companyId
            searchText += c.salespersonName !== undefined && c.salespersonName !== "" ? c.salespersonName : ""
        
            if(searchText.toLowerCase().includes(this.companiesSearch.toLowerCase())) companiesArray.push(c)
          }
          else{
            companiesArray.push(c)
          }
        }

        this.amountOfCompanies = companiesArray.length
        this.amountOfCompaniesWithoutSalesperson = amountOfCompaniesWithoutSalesperson
        this.amountOfCompaniesNoOrderForTwoYears = amountOfCompaniesNoOrderForTwoYears
        //this.amountOfCompaniesWithoutSalesperson = companiesArray.filter( c => !c.salesperson).length
        //this.amountOfCompaniesNoOrderForTwoYears = companiesArray.filter( c => c.noOrdersInTwoYears === true).length

        var sortedCompanies = companiesArray.sort((a,b)=>{
          if(a.companyName === undefined) console.log(a)
          if(b.companyName === undefined) console.log(b)
          var nameA= a.companyName.toLowerCase(), nameB=b.companyName.toLowerCase();
          if (nameA > nameB) {
            return 1;
          }
          if (nameB > nameA) {
            return -1;
          }
          return 0;
        })

        var sliceEnd = 0
        if(this.companiesToShow > sortedCompanies.length) {
          this.isThereMoreCompaniesToShow = false
          sliceEnd = sortedCompanies.length
        }
        else {
          this.isThereMoreCompaniesToShow = true
          sliceEnd = this.companiesToShow
        }
        return sortedCompanies.slice(0,sliceEnd)
      },
      ...mapFields({
        settings:"settings",
        device:"device",
        contacts:"contact.contacts",
        orders:"order.orders",
        companies:"company.companies",
        staff:"staff.staff",
        selectedCompanyId:"views.companies.selectedCompany.companyId",
        user:"user",
        newCompanyModalVisible:"modals.company.new.visible",
      }),
    },
    methods: {
      async batchCreateCompanies(newCompanies){
        console.log(newCompanies)
        for (var i = 0; i < 50; i++){
          var c = newCompanies[i]
          //console.log(c)
          if(c){
            var companyDBId = await this.$store.dispatch('company/set', {
              companyName:c.companyName,
              companyId:'',
              paymentTerm:"14 päivää netto",
              deliveryAddress:c.deliveryAddress,
              deliveryPostalCode:c.deliveryPostalCode,
              deliveryCity:c.deliveryCity,
              deliveryCountry:'Finland',
              billingFormat:'',
              billingEmail: '',
              eBillingAddress: '',
              eBillingOperator: '',
              clientPrintDetailsEmail: '',
              differentBillingEmail: false,
              differentBillingAddress: false,
              billingAddress:'',
              billingPostalCode:'',
              billingCity:'',
              billingCountry:'Finland',
              salesperson:c.salesperson,
              customerProductsWarehoused:false,
              shopifyCustomerIdTag:'',
              companyComments:c.companyComments
            })
            var contactData = {
              companyId:companyDBId,
              firstName:c.firstName,
              lastName:c.lastName,
              phone:c.contactPhone,
              email:c.contactEmail,
              sendConfirmation: false,
              comments:c.contactComments,
            }
            var contactDBId = await this.$store.dispatch('contact/set', contactData)
          }
        }
        this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Lisätty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
      },
      importSalesContacts(){
        var t = this
        var encoding = 'UTF-8'
        return new Promise(async function(resolve, reject) {
          try {
            var companyNames = t.companyNames
            console.log(companyNames)
            
            var rows = 0
            var companies = []
            Papa.parse(fileInputCustomers.files[0], {
              encoding,
              step: function(row) {
                if(rows == 0){}
                else {
                  var companyName = row.data[0] ?  row.data[0].trim() :''
                  var deliveryAddress = row.data[1] ? row.data[1] : ''
                  var deliveryPostalCode = row.data[2] ? row.data[2] :''
                  var deliveryCity = row.data[3] ? row.data[3] : ''
                  var deliveryCountry = 'Finland'
                  var companyComments = row.data[4] ? row.data[4] : ''
                  var firstName = row.data[5] ? row.data[5] : ''
                  var lastName = row.data[6] ? row.data[6] : ''
                  var contactComments = row.data[7] ? row.data[7] : ''
                  
                  var contactEmail = row.data[8] ? row.data[8] :''
                  var contactPhone = row.data[9] ? row.data[9] : ''
                  
                  var company = {
                    companyName,
                    deliveryAddress,
                    deliveryPostalCode,
                    deliveryCity,
                    deliveryCountry,
                    companyComments,
                    firstName,
                    lastName,
                    contactComments,
                    contactEmail,
                    contactPhone,
                    salesperson:'I7RPIfMJIbYurRauvSR35yp9MJD2'
                  }
                  if(companyNames[companyName] && companyNames[companyName].salesperson === 'I7RPIfMJIbYurRauvSR35yp9MJD2'){
                    console.log(company)
                  }
                  else {
                    companies.push(company)
                  }
                }
                rows = rows+ 1
              },
              complete: function(results) {
                //console.log(companies)
                t.batchCreateCompanies(companies)
                //t.batchUpdateLeads(existingLeads)
                resolve(true)
              }
            });
          }
          catch(e){
            console.log(e)
            resolve(false)
          }
        })
      },
      customFormatter(date) {
        if (date.seconds) {
          var myDate = new Date(date.seconds*1000);
          return dateFormat(myDate, "yyyy-mm-dd")
        }
        else if (date !== undefined && date.seconds === undefined){
          return dateFormat(date, "yyyy-mm-dd")
        }
        return ''
      },
      changeOwner(){
        var company,s
        for (const companyId of Object.keys(this.companies)) {
          company = this.companies[companyId]
          s = company.salesperson
          if (s === 'GUIKE8RcUWWTNAgAomExiLuzE6G2') {
            this.$store.dispatch('company/set', {
              id:company.id,
              salesperson:'CfssvG9CYWWCoLSkeoR6FVXy6K72'
            })
            
            //console.log(company.companyName)
          }
        }
      },
      generateCompaniesData(){
        var companiesData = {}
        var c
        var company 
        var twoYearsAgo = new Date()
        twoYearsAgo.setFullYear(twoYearsAgo.getFullYear() - 2);

        var i = 0
        for (const key of Object.keys(this.contacts)) {
          c = this.contacts[key]
          if(c.companyId === undefined || c.companyId === '' || this.companies[c.companyId] === undefined || this.companies[c.companyId] === "") {continue}
          companiesData[c.companyId] === undefined ? companiesData[c.companyId] = {} : ""
          Object.defineProperty(companiesData, c.companyId, { configurable: false });
          company = this.companies[c.companyId]
          companiesData[c.companyId].id = c.companyId
          companiesData[c.companyId].created_at = company.created_at
          companiesData[c.companyId].latestOrderDate = company.latestOrderDate
          companiesData[c.companyId].noOrdersInTwoYears = false
          if(!company.latestOrderDate) companiesData[c.companyId].noOrdersInTwoYears = true
          else if(new Date(company.latestOrderDate) < twoYearsAgo) companiesData[c.companyId].noOrdersInTwoYears = true
          //latestOrderDate
          companiesData[c.companyId].totalOrders = company.totalOrders
          companiesData[c.companyId].netvisorId = company.netvisorId
          companiesData[c.companyId].companyName = company.companyName
          companiesData[c.companyId].contactStatus = company.contactStatus
          companiesData[c.companyId].deliveryAddress = company.deliveryAddress !== undefined ? company.deliveryAddress : ''
          companiesData[c.companyId].deliveryPostalCode = company.deliveryPostalCode !== undefined ? company.deliveryPostalCode : ''
          companiesData[c.companyId].deliveryCity = company.deliveryCity !== undefined ? company.deliveryCity : ''
          companiesData[c.companyId].deliveryCountry = company.deliveryCountry !== undefined ? company.deliveryCountry : ''
          companiesData[c.companyId].contacts === undefined ? companiesData[c.companyId].contacts = c.firstName+" "+c.lastName+" "+ c.phone : companiesData[c.companyId].contacts = companiesData[c.companyId].contacts + '\n'+c.firstName+" "+c.lastName+ " "+ c.phone
          companiesData[c.companyId].salesperson = company.salesperson
          companiesData[c.companyId].salespersonName = this.staff[company.salesperson] !== undefined ? this.staff[company.salesperson].firstName + ' ' + this.staff[company.salesperson].lastName : '' 
          
          companiesData[c.companyId].companyId = company.companyId
          companiesData[c.companyId].industry = company.industry ? company.industry : ''
          companiesData[c.companyId].address = company.deliveryAddress+' '+company.deliveryPostalCode+' '+company.deliveryCity+', '+company.deliveryCountry
          companiesData[c.companyId].paymentTerm = company.paymentTerm
          companiesData[c.companyId].billingFormat = company.billingFormat !== undefined && company.billingFormat !== "" ? this.settings.billingFormats[company.billingFormat].fi : ""
          companiesData[c.companyId].differentBillingEmail = company.differentBillingEmail
          companiesData[c.companyId].billingEmail = company.billingEmail
          companiesData[c.companyId].differentBillingAddress = company.differentBillingAddress
          companiesData[c.companyId].billingAddress = company.billingAddress
          companiesData[c.companyId].billingCity = company.billingCity
          companiesData[c.companyId].billingCountry = company.billingCountry
          companiesData[c.companyId].eBillingAddress = company.eBillingAddress
          companiesData[c.companyId].eBillingOperator = company.eBillingOperator
        }
        for (const companyId of Object.keys(this.companies)) {
          if(companiesData[companyId] === undefined) {
            companiesData[companyId] = {}
            Object.defineProperty(companiesData, companyId, { configurable: false });
            company = this.companies[companyId]
            companiesData[companyId].id = companyId
            companiesData[companyId].created_at = company.created_at
            companiesData[companyId].latestOrderDate = company.latestOrderDate
            companiesData[c.companyId].noOrdersInTwoYears = false
            if(!company.latestOrderDate) companiesData[c.companyId].noOrdersInTwoYears = true
            else if(new Date(company.latestOrderDate) && company.latestOrderDate < twoYearsAgo) companiesData[c.companyId].noOrdersInTwoYears = true
            companiesData[companyId].totalOrders = company.totalOrders
            companiesData[companyId].netvisorId = company.netvisorId
            companiesData[companyId].companyName = company.companyName
            companiesData[companyId].contactStatus = company.contactStatus
            companiesData[companyId].contacts === ''
            companiesData[companyId].salesperson =  company.salesperson
            companiesData[companyId].salespersonName = this.staff[company.salesperson] !== undefined ? this.staff[company.salesperson].firstName + ' ' + this.staff[company.salesperson].lastName : '' 
            companiesData[companyId].companyId = company.companyId
            companiesData[companyId].industry = company.industry ? company.industry : ''
            companiesData[companyId].deliveryAddress = company.deliveryAddress !== undefined ? company.deliveryAddress : ''
            companiesData[companyId].deliveryPostalCode = company.deliveryPostalCode !== undefined ? company.deliveryPostalCode : ''
            companiesData[companyId].deliveryCity = company.deliveryCity !== undefined ? company.deliveryCity : ''
            companiesData[companyId].deliveryCountry = company.deliveryCountry !== undefined ? company.deliveryCountry : ''
            companiesData[companyId].paymentTerm = company.paymentTerm
            companiesData[companyId].billingFormat = company.billingFormat !== undefined && company.billingFormat !== "" ? this.settings.billingFormats[company.billingFormat].fi : ""
            companiesData[companyId].differentBillingEmail = company.differentBillingEmail
            companiesData[companyId].billingEmail = company.billingEmail
            companiesData[companyId].differentBillingAddress = company.differentBillingAddress
            companiesData[companyId].billingAddress = company.billingAddress
            companiesData[companyId].billingCity = company.billingCity
            companiesData[companyId].billingCountry = company.billingCountry
            companiesData[companyId].eBillingAddress = company.eBillingAddress
            companiesData[companyId].eBillingOperator = company.eBillingOperator
          }
        }
        
        this.companiesData = companiesData
      },
      
      exportList(){
        var data = []
        var contact = ''
        var name = ''
        console.log(this.exportSalespersonFilter)
        var lastSoldDates = {}
        Object.keys(this.orders).forEach(oId => {
          var o = this.orders[oId]
          var y_tunnus = this.companies[o.companyId] && this.companies[o.companyId].companyId ? this.companies[o.companyId].companyId.trim() : ''
          if(y_tunnus){
            console.log(y_tunnus)
            if(y_tunnus === '1887090-1') console.log(o)
            if(!lastSoldDates[y_tunnus] && o.created_at.seconds){
              lastSoldDates[y_tunnus] = {}
              lastSoldDates[y_tunnus].seconds = o.created_at.seconds
              lastSoldDates[y_tunnus].date = this.customFormatter(o.created_at)
            }
            else {
              //console.log("---START----")
              //console.log({prev_date:lastSoldDates[o.companyId].seconds,this_date:o.created_at.seconds})
              //console.log({prev_date:lastSoldDates[o.companyId].date,this_date:this.customFormatter(o.created_at)})//this.customFormatter(o.created_at)
              if(new Date(lastSoldDates[y_tunnus].seconds*1000) < new Date(o.created_at.seconds*1000)){
                //console.log({prev_date:lastSoldDates[o.companyId].date,this_date:this.customFormatter(o.created_at)})
                lastSoldDates[y_tunnus].seconds = o.created_at.seconds
                lastSoldDates[y_tunnus].date = this.customFormatter(o.created_at)
              }
              //console.log("---END----")
            }
          }
        })
        for (const key of Object.keys(this.contacts)) {
          if (this.contacts[key] === undefined) {console.log(this.contacts[key]); continue}
          if(this.companies[this.contacts[key].companyId] === undefined){continue}
          var latestEmailOpen = this.contacts[key].latestEmailOpen ? this.customFormatter(this.contacts[key].latestEmailOpen) : ''
          var created_at = this.contacts[key].created_at ? this.customFormatter(this.contacts[key].created_at) : ''
          var y_tunnus2 = this.companies[this.contacts[key].companyId] && this.companies[this.contacts[key].companyId].companyId ?  this.companies[this.contacts[key].companyId].companyId.trim() : ''
          contact = {
            myyjä: this.staff[this.companies[this.contacts[key].companyId].salesperson] !== undefined ? this.staff[this.companies[this.contacts[key].companyId].salesperson].firstName : '',
            järjestelmään_lisätty_pvm: created_at,
            yrityksen_nimi: this.companies[this.contacts[key].companyId].companyName,
            yrityksen_y_tunnus: this.companies[this.contacts[key].companyId].companyId,
            yrityksen_osoite: this.companies[this.contacts[key].companyId].deliveryAddress,
            yrityksen_kaupunki: this.companies[this.contacts[key].companyId].deliveryCity,
            yrityksen_maa: this.companies[this.contacts[key].companyId].deliveryCountry,
            kontaktin_nimi:this.contacts[key].firstName + ' ' +this.contacts[key].lastName,
            kontaktin_puhelinnumero:this.contacts[key].phone ? this.contacts[key].phone.replace(' ', '') : '',
            kontaktin_sähköpostiosoite:this.contacts[key].email ? this.contacts[key].email.replace(' ', '') : '',
            viimeinen_kauppa_pvm:lastSoldDates[y_tunnus2] ? lastSoldDates[y_tunnus2].date : '1980-01-01',
            viim_sähköpostin_avaus:latestEmailOpen
          }
          if(this.exportSalespersonFilter === 'all'){
            name = 'Kaikki'
            data.push(contact)
          }
          else {
            name = this.staff[this.exportSalespersonFilter].firstName
            if(this.exportSalespersonFilter  === this.companies[this.contacts[key].companyId].salesperson) data.push(contact)
          }
        }

        data = data.sort(function(a,b){
          return new Date(a.viimeinen_kauppa_pvm) - new Date(b.viimeinen_kauppa_pvm);
        });

        const options = { 
          fieldSeparator: ',',
          quoteStrings: '"',
          decimalSeparator: '.',
          showLabels: true,
          filename:name + ' Avecor Kontaktiedot', 
          //showTitle: true,
          //title:name +  'Kontaktitiedot',
          useTextFile: false,
          useBom: true,
          useKeysAsHeaders: true,
          // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
        };
        
        const csvExporter = new ExportToCsv(options);
        csvExporter.generateCsv(data);
      },
      exportCities(){
        var data = []
        var cities = {}
        var name = ''

        for (const key of Object.keys(this.companies)) {
          var c = this.companies[key]
          cities[c.salesperson] ?  '' : cities[c.salesperson] = {}
          
          c.deliveryCity ? '' : console.log(c.deliveryCity)
          if(!c.salesperson) continue
          if(this.staff[c.salesperson].isExit) continue
          if(!c.deliveryCity) continue
          if(!c.deliveryPostalCode) continue
          var city = c.deliveryCity.toLowerCase()
          city = city.charAt(0).toUpperCase() + city.slice(1);
          /* cities[c.salesperson][c.deliveryCity] ? '' : cities[c.salesperson][c.deliveryCity] = {}
          cities[c.salesperson][c.deliveryCity][c.deliveryPostalCode] ? cities[c.salesperson][c.deliveryCity][c.deliveryPostalCode] += 1 : cities[c.salesperson][c.deliveryCity][c.deliveryPostalCode] = 1 */
          cities[c.salesperson][c.deliveryPostalCode] ? '' : cities[c.salesperson][c.deliveryPostalCode] = {}
          cities[c.salesperson][c.deliveryPostalCode][city] ? cities[c.salesperson][c.deliveryPostalCode][city] += 1 : cities[c.salesperson][c.deliveryPostalCode][city] = 1
        }

        Object.keys(cities).forEach(sp => {
          if(!this.staff[sp]) return
          /* Object.keys(cities[sp]).forEach(cityKey => {
            Object.keys(cities[sp][cityKey]).forEach(postalCodeKey => {
              var total = cities[sp][cityKey][postalCodeKey]
              var city_obj = {
                salesperson: this.staff[sp].firstName,
                kaupunki: cityKey,
                postikoodi:'--'+postalCodeKey,
                määrä:total,
              }
              data.push(city_obj)
            })
          }) */
          Object.keys(cities[sp]).forEach(postalCodeKey => {
            Object.keys(cities[sp][postalCodeKey]).forEach(cityKey => {
              var total = cities[sp][postalCodeKey][cityKey]
              var pKey = postalCodeKey
              if(postalCodeKey.length === 2) pKey = '000'+postalCodeKey
              if(postalCodeKey.length === 3) pKey = '00'+postalCodeKey
              if(postalCodeKey.length === 4) pKey = '0'+postalCodeKey
              
              var city_obj = {
                salesperson: this.staff[sp].firstName,
                kaupunki: cityKey,
                postikoodi:'--'+pKey,
                määrä:total,
              }
              data.push(city_obj)
            })
          })
        })

        data = data.sort((a,b)=>{
          if(a.salesperson === undefined) return 0
          if(b.salesperson === undefined) return 0
          var nameA=a.salesperson.toLowerCase().trim(), nameB=b.salesperson.toLowerCase().trim();
          if (nameA > nameB) {return 1;}
          if (nameB > nameA) {return -1;}
          return 0;
        })
        

        const options = { 
          fieldSeparator: ',',
          quoteStrings: '"',
          decimalSeparator: '.',
          showLabels: true,
          filename:'Kaupungit' + ' Avecor Kontaktiedot', 
          //showTitle: true,
          //title:name +  'Kontaktitiedot',
          useTextFile: false,
          useBom: true,
          useKeysAsHeaders: true,
          // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
        };
        
        const csvExporter = new ExportToCsv(options);
        csvExporter.generateCsv(data);
      },

      updateCompanyContactStatus(companyId, field,value){
        var val = value.target.value
        console.log({companyId,field,val} )
        this.$store.dispatch('company/set', {
          id:companyId,
          [field]:val,
        }).then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
      },
      copyToClipboard (text) {
        this.$clipboard(text)
        this.$store.dispatch('showSnack', { snack:true, snackTimeout:1000, snackText:"Id kopioitu", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
      },
      customFormatter(date) {
        if (date.seconds) {
          var myDate = new Date(date.seconds*1000);
          return dateFormat(myDate, "yyyy-mm-dd")
        }
        else if (date !== undefined && date.seconds === undefined){
          return dateFormat(date, "yyyy-mm-dd")
        }
        return ''
      },
      deleteReference(id){
        console.log(id)
        if (confirm('Haluatko varmasti poistaa referenssin tiedot?')) {
          this.$store.dispatch('order/set', {
            id,
            referenceText:'',
            referenceOption:''
          })
        }
      },
      async deleteCompany (item) {
        console.log(item.totalOrders)
        if (confirm('Haluatko varmasti poistaa?')) {
          this.$store.dispatch('showSnack', { snack:true, snackTimeout:0, snackText:"Poistetaan yritys ja siihen liittyvät kontaktit...", snackButtonText: "", errorType:"", snackColor:'deep-blue',right:true,top:true})
          try{
            var url = this.settings.dev ? 'http://0.0.0.0:5000/avecor-709ff/us-central1/deleteCompany': 'https://us-central1-avecor-709ff.cloudfunctions.net/deleteCompany'
            let res = await axios.post(url,
              { companyId:item.id },
            );
            console.log(res.data)
            this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:res.data.message, snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})

            if (item.id === this.selectedCompanyId) this.selectedCompanyId = ""
          }
          catch(e){
            var msg = e.response && e.response.data && e.response.data.message ? e.response.data.message : e.message
            this.$store.dispatch('showSnack', { snack:true, snackTimeout:6000, snackText:msg, snackButtonText: "OK", errorType:"", snackColor:'error',right:true,top:true})
          }
        }
      },
      
      inlineSaveCompany(cId,field,v){
        console.log({cId,field,v})
        this.$store.dispatch('company/set', {
          id:cId,
          [field]:v
        })
        .then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
      },
      inlineSave (item) {
        let {id, ...y} = item;
        this.$store.dispatch('company/set', {
          id,
          ...y
        })
        .then(this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
      },
      /* importCompanies(){
        var rows = 0
        var store = this.$store
        Papa.parse(fileInput.files[0], {
          step: function(row) {
            //console.log("Row:", row.data);
            if(rows >= 901 && rows <= 1100) {
              console.log(rows)  
              console.log("Row:", row.data)
              var netvisorId = row.data[0][0]
              var companyName = row.data[0][1]
              var salesperson = row.data[0][2]
              console.log(salesperson)
              salesperson = salesperson.trim()
              if(salesperson === "Miko Kahlos") salesperson = "y9ZVH4HpzFWuS9TzONQUJadQZ4T2"
              else if(salesperson === "Hanna Liukkonen") salesperson = "2hq19s6eQHSrEhwXiAeDGxo0Q5e2"
              else if(salesperson === "Greetta Berg") salesperson = "sNTkkDHpVGg0U9P8aQuTw43fpKH3"
              else if(salesperson === "Sami Maunu") salesperson = "CfssvG9CYWWCoLSkeoR6FVXy6K72"
              else if(salesperson === "Atte Palonen") salesperson = "GTNKFjWUHNhcAJVbORirRPNvCnv1"
              else if(salesperson === "Markku Nuutinen") salesperson = "eZ4PiIehfVg7xo0J2tZV8tYtLZ23"
              else if(salesperson === "Henri Potila") salesperson = "zNBbbWRgacVUU3TU06kTSLesn872"
              else if(salesperson === "Mikael Hanslin") salesperson = "905Is6XLiZZA2M8AdsADYLc8anP2"
              else salesperson = ""
              var companyId = row.data[0][3]
              var deliveryAddress = row.data[0][4]
              var deliveryPostalCode = row.data[0][5]
              var deliveryCity = row.data[0][6]
              var deliveryCountry = row.data[0][7]
              var billingEmail = row.data[0][8]
              var eBillingAddress = row.data[0][9]
              var eBillingOperator = row.data[0][10]
              deliveryCity = deliveryCity.charAt(0).toUpperCase() + deliveryCity.slice(1).toLowerCase();
              var billingFormat = ""
              eBillingAddress && eBillingAddress !== "" ? billingFormat = "eInvoice" : ""
              billingEmail && billingEmail !== "" ? billingFormat = "email" : ""

              var data = {
                netvisorId,
                companyName,
                salesperson,
                companyId,
                deliveryAddress,
                deliveryPostalCode,
                deliveryCity,
                deliveryCountry,
                billingAddress:'',
                billingPostalCode:'',
                billingCity:'',
                billingCountry:'',
                billingEmail,
                eBillingAddress,
                eBillingOperator,
                billingFormat,
                companyComments:''
              }
              //console.log(data)

              store.dispatch('company/set', data)
                .then(store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true}))
              
            }
            rows = rows+ 1
            
          },
          complete: function(results) {
            console.log(results);
          }
        });
      }, */
      
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/blocks/CompaniesTable.vue